export default function BlockFormatting (pButton)
{
  this.createBlockFormattingButton = () =>
  {
    const formatStyles = pButton.pAttribute.parameters.styles,
          len = formatStyles.length;

    pButton.eButtonText = pButton.pGroup.pToolbar.tDoc.createElement('DIV');
    pButton.eButtonText.setAttribute('style', 'position: absolute; left: 0px; top: 0px; z-index: 7; width: ' + (pButton.pAttribute.width - 24) + 'px; height: ' + pButton.pAttribute.height + 'px; overflow: hidden; margin-right: 17px; padding: 7px 0px 0px 7px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: normal; font-style: normal; color: #C1C1C1; white-space: nowrap;');
    pButton.eButtonText.innerHTML = pButton.pAttribute.title;

    pButton.eButton.appendChild(pButton.eButtonText);

    pButton.pAttribute.parameters.styleIdList = {};

    for (let i = 0; i < len; i++)
    {
      pButton.pAttribute.parameters.styleIdList[formatStyles[i]['tag'] + '|' + formatStyles[i]['cssClass']] = i;
    }
  };


  this.preInitBlockFormattingDropdownButton = (isNewTheme) =>
  {
    let dropdownInnerHTML,
        htmlForEditor = '',
        formatStyles = pButton.pAttribute.parameters.styles,
        len = formatStyles.length;

    pButton.pAttribute.parameters.dropdownItemsLenght = len;

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="width: 250px; padding: 5px 0; background-color: #F5F5F5;">';

    for (let i = 0; i < len; i++)
    {
      dropdownInnerHTML += '<div id="idItemsContainer_' + i + '" style="position: relative; width: 227px; overflow: hidden; padding: 5px 12px 5px 11px;"' + ((formatStyles[i]['cssClass'] != null && formatStyles[i]['cssClass'] !== '') ? ' data-themedependent="1"' : '') + ' ' + (formatStyles[i].isOptional ? ' data-isitemoptional="1"' : '') + '>';
      dropdownInnerHTML += '  <div style="width: 227px; overflow: hidden; white-space: nowrap;">';
      dropdownInnerHTML += '    <div id="idClassForItem_' + i + '">';
      dropdownInnerHTML += '      <' + formatStyles[i]['tag'] + ' ' + ((formatStyles[i]['cssClass'] != null && formatStyles[i]['cssClass'] !== '') ? ' class="' + formatStyles[i]['cssClass'] + '"' : '') + '" style="position: static; margin: 0; padding: 0;" data-wablockformattingitemindex="' + i + '">';
      dropdownInnerHTML +=          formatStyles[i]['name'];
      dropdownInnerHTML += '      </' + formatStyles[i]['tag'] + '>';
      dropdownInnerHTML += '    </div>';
      dropdownInnerHTML += '  </div>';
      dropdownInnerHTML += '  <div ddtype="Item" ddvalue="' + formatStyles[i]['tag'] + '|' + formatStyles[i]['cssClass'] + '" dddisabled="false" style="position: absolute; top: 0; left: 0; width: 248px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: ' + ((BEditor.browser.isIE) ? 'hand' : 'pointer') + ';"></div>';
      dropdownInnerHTML += '</div>';

      htmlForEditor += '<' + formatStyles[i]['tag'] + ' class="' + formatStyles[i]['cssClass'] + '" style="position: static; margin: 0; padding: 0;" data-wablockformattingitemindex="' + i + '">' + formatStyles[i]['name'] + '</' + formatStyles[i]['tag'] + '>';
    }

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_Dropdown', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML, null, null, null, null, null, { 'isReload': !!isNewTheme });
    pButton.initDropdownComponents();
    BEditor.Dropdowns[pButton.pAttribute.name] = pButton.pAttribute.Dropdown;
    BEditor.Dropdowns[pButton.pAttribute.name].htmlForEditor = htmlForEditor;
  };


  this.setFormattingDropdownItemsClass = (className) =>
  {
    if (pButton.pAttribute.Dropdown.isObjValid)
    {
      if (className == null)
      {
        return;
      }

      let elements = pButton.pAttribute.Dropdown.getIFrame().document.querySelectorAll('DIV[id^=idClassForItem]');

      for (let i = 0; i < elements.length; i++)
      {
        elements[i].className = className;
      }
    }
    else
    {
      setTimeout(() => this.setFormattingDropdownItemsClass(className), 100);
    }
  };


  this.showHideFormattingDropdownOptionalItems = (isShow) =>
  {
    if (pButton.pAttribute.Dropdown.isObjValid)
    {
      let elements = pButton.pAttribute.Dropdown.getIFrame().document.querySelectorAll('DIV[data-isitemoptional]');

      for (let i = 0; i < elements.length; i++)
      {
        elements[i].style.display = (isShow ? 'block' : 'none');
      }

      pButton.pAttribute.parameters.isOptionalItemHided = !isShow;
    }
    else
    {
      setTimeout(() => this.showHideFormattingDropdownOptionalItems(isShow), 100);
    }
  };
}